import { render, staticRenderFns } from "./kllk-menu-phone.vue?vue&type=template&id=28971fec&scoped=true"
import script from "./kllk-menu-phone.vue?vue&type=script&lang=js"
export * from "./kllk-menu-phone.vue?vue&type=script&lang=js"
import style0 from "./kllk-menu-phone.vue?vue&type=style&index=0&id=28971fec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28971fec",
  null
  
)

export default component.exports